var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWorkStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_661_4562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4558 0H10.5442L0 10.5442V25.4558L10.5442 36H25.4558L36 25.4558V10.5442L25.4558 0Z",
    fill: "#FF2147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7585 34.3167H11.2415L1.68335 24.7585V11.2413L11.2415 1.68359H24.7585L34.3166 11.2415V24.7585L24.7585 34.3167ZM11.6155 33.4138H24.3845L33.4138 24.3845V11.6153L24.3845 2.58619H11.6155L2.58619 11.6153V24.3843L11.6155 33.4136V33.4138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7606 23.7874C24.7606 26.1807 22.8137 28.1277 20.4203 28.1277H17.1506C15.5111 28.1277 14.0295 27.2206 13.2843 25.7606C13.2832 25.758 13.2817 25.7557 13.2803 25.7531L8.95667 17.752C8.72 17.2639 8.87747 16.6722 9.32572 16.3723C9.50005 16.2544 9.70508 16.1921 9.91878 16.1921C10.3103 16.1921 10.6597 16.3922 10.8535 16.7275C10.8563 16.7322 10.8591 16.7369 10.8619 16.7416L13.2433 20.4633C13.33 20.5987 13.4957 20.6604 13.6496 20.6156C13.8038 20.5706 13.9097 20.4291 13.9097 20.2686V10.7669C13.9097 10.1687 14.3966 9.68176 14.9949 9.68176C15.2826 9.68176 15.5558 9.79494 15.7609 9.99716C15.9666 10.2057 16.08 10.4792 16.08 10.7667V18.7237C16.08 18.9233 16.2419 19.0855 16.4416 19.0855C16.6412 19.0855 16.8031 18.9236 16.8031 18.7237V8.95818C16.8031 8.35996 17.29 7.87305 17.8882 7.87305C18.176 7.87305 18.4492 7.98622 18.6542 8.18844C18.86 8.39699 18.9731 8.6702 18.9731 8.95795V18.7235C18.9731 18.9231 19.1351 19.0853 19.3347 19.0853C19.5343 19.0853 19.6963 18.9233 19.6963 18.7235V10.7664C19.6963 10.1682 20.1829 9.68129 20.7814 9.68129C21.0691 9.68129 21.3424 9.79447 21.5474 9.99669C21.7531 10.2052 21.8665 10.4787 21.8665 10.7662V18.7232C21.8665 18.9229 22.0284 19.085 22.2281 19.085C22.4277 19.085 22.5896 18.9231 22.5896 18.7232V12.9362C22.5896 12.338 23.0763 11.8511 23.6748 11.8511C23.9625 11.8511 24.2357 11.9643 24.441 12.1665C24.6467 12.375 24.7599 12.6483 24.7599 12.936V23.7867L24.7606 23.7874Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_661_4562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkStop);
export default __webpack_public_path__ + "static/media/icon_work_stop.5cd73477b7a77d559724384cacbf3339.svg";
export { ForwardRef as ReactComponent };